import { get, isEmpty } from "lodash";
import ApiImage from "./ApiImage";
import ContentfulAuthor from "models/data/contentful/ContentfulAuthor";
import ContentfulToApiAuthor from "models/data/mappings/ContentfulToApiAuthor";

class ApiAuthor {
  static default = {
    id: "",
    fullName: "",
    shortBiography: "",
    picture: ApiImage.default,
    twitter: "",
    instagram: "",
    slug: "",
  };

  static id = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "id", ApiAuthor.default.id);

  static fullName = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "fullName", ApiAuthor.default.fullName);

  static pictureUrl = (apiAuthor: ApiAuthor): string =>
    ApiImage.url(ApiAuthor.picture(apiAuthor));

  static shortBiography = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "shortBiography", ApiAuthor.default.shortBiography);

  static picture = (apiAuthor: ApiAuthor): ApiImage =>
    get(apiAuthor, "picture", ApiAuthor.default.picture);

  static twitter = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "twitter", ApiAuthor.default.twitter);

  static hasTwitter = (apiAuthor: ApiAuthor): boolean =>
    !isEmpty(ApiAuthor.twitter(apiAuthor));

  static instagram = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "instagram", ApiAuthor.default.instagram);

  static hasInstagram = (apiAuthor: ApiAuthor): boolean =>
    !isEmpty(ApiAuthor.instagram(apiAuthor));

  static metaDescription = (apiAuthor: ApiAuthor): string =>
    `Find in-depth articles, interviews, news, and more from ${ApiAuthor.fullName(
      apiAuthor
    )}. ${ApiAuthor.shortBiography(apiAuthor).split(". ")[0]}.`;

  static slug = (apiAuthor: ApiAuthor): string =>
    get(apiAuthor, "slug", ApiAuthor.default.slug);

  static async fetchWithId(authorId: string) {
    const contentfulAuthor = await ContentfulAuthor.fetchWithId(authorId);
    return ContentfulToApiAuthor.map(contentfulAuthor);
  }

  static async fetchWithSlug(authorSlug: string) {
    const contentfulAuthor = await ContentfulAuthor.fetchWithSlug(authorSlug);
    return ContentfulToApiAuthor.map(contentfulAuthor);
  }
}

export default ApiAuthor;
